<template>
    <div class="workpostscanproduct" id="workpostscanproduct">
        <workstation-scan-products
            v-if="workstation"
            :key="workstation.id"
            :workstation="workstation"
            ref="scanner"
            :action-buttons="actionButtons"></workstation-scan-products>
    </div>
</template>
<script>
import workstationScanProducts from '../components/scanProducts/WorkstationScanProducts';
import workstationApi from '../api/workstation';
import IdParamMixin from '../mixins/id-param';

export default {
    mixins: [IdParamMixin()],
    data() {
        return {
            workstation: null,
            actionButtons: [],
        };
    },
    methods: {
        load() {
            const id = this.idParam;
            workstationApi.fetchById(id).then((response) => {
                const workstation = response.data.data;
                this.workstation = workstation;
                this.$store.commit(
                    'general/setPageTitle',
                    this.workstation.label,
                    { root: true }
                );
            });
        },
    },
    beforeRouteLeave(to, from, next) {
        if (!this.$refs.scanner?.handleBeforeRouteLeave) {
            return next();
        }
        this.$refs.scanner.handleBeforeRouteLeave(to, from, next);
    },
    components: {
        workstationScanProducts,
    },
};
</script>
